import { render, staticRenderFns } from "./BedsideScreenList.vue?vue&type=template&id=6e720b02&scoped=true"
import script from "./BedsideScreenList.vue?vue&type=script&lang=js"
export * from "./BedsideScreenList.vue?vue&type=script&lang=js"
import style0 from "./BedsideScreenList.vue?vue&type=style&index=0&id=6e720b02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e720b02",
  null
  
)

export default component.exports